// Get Group Users
export const GET_GROUP_USERS_REQUEST = 'GET_GROUP_USERS_REQUEST';
export const GET_GROUP_USERS_DONE = 'GET_GROUP_USERS_DONE';
export const GET_GROUP_USERS_FAILED = 'GET_GROUP_USERS_FAILED';

// Operations
export const GROUP_USERS_SET_PAGE = 'GROUP_USERS_SET_PAGE';